module.exports = __webpack_public_path__ + "index/img/fenxiangtupian.4e71f4e7.png";